import type { FormItem } from '@ohpen/enso-ui';

// Which fields of a create form the assistant may fill in, read off the form's own schema so the answer is
// the form the user will be looking at rather than a list of names kept beside it.

const staticProps = (props: FormItem['formItemProps'] | FormItem['fieldProps']): Record<string, unknown> =>
  props !== null && typeof props === 'object' ? (props as Record<string, unknown>) : {};

/**
 * The fields a schema offers for filling in: the ones with a plain name, shown, and not disabled. A field
 * whose props are computed per form instance is offered, since what it resolves to is the mounted form's
 * business and its own validation still has the last word.
 */
export const createFormFields = (schema: readonly FormItem[]): string[] =>
  schema
    .filter(item => typeof item.dataIndex === 'string')
    .filter(item => staticProps(item.formItemProps).hidden !== true && staticProps(item.fieldProps).disabled !== true)
    .map(item => item.dataIndex as string);
